import {AfterViewInit, Component, OnInit} from '@angular/core';
import {SharedService} from '../../shared-module/services';
import { Title, Meta } from "@angular/platform-browser";
@Component({
    selector: 'app-tax-deductible',
    templateUrl: './tax-deductible.component.html',
    styleUrls: ['./tax-deductible.component.scss']
})
export class TaxDeductibleComponent implements OnInit, AfterViewInit {

    constructor(private sharedService: SharedService, 
                private title: Title,
                private meta: Meta) {
    }

    ngOnInit() {
        this.title.setTitle("Tax Deductible Art");
        this.meta.updateTag({ 
            name: 'description',
            content: 'U.S. patrons and art collectors who acquire original Armenian art through our website get at least 57,5% income tax deduction of their art purchases.'
        }); 
    }

    ngAfterViewInit(): void {
        document.querySelector('mat-drawer-content').scrollTo(0, 0);
    }
}
